import { Pipe, PipeTransform } from '@angular/core';

/**
 * @description: This pipe is used to format the chemical element by wrapping all numbers in a <sub> tag
 * @param value {string} required
 * @returns {string}
 */
@Pipe({
  name: 'formatChemicalElement',
  standalone: false,
})
export class FormatChemicalElementPipe implements PipeTransform {
  transform(value: any): any {
    return this.formatChemicalElement(value);
  }

  // Returns a formatted HTML string with the atomic substript from a chemical element
  formatChemicalElement(element) {
    // Check if the string contains numbers
    if (!/\d/.test(element)) {
      // If it doesn't contain numbers, return the original string
      return element;
    }

    // If it contains numbers, use a regex to find all numbers and wrap them with <sub> tags
    return element.replace(/(\d+)/g, '<sub>$1</sub>');
  }
}
